import { Dispatch, SetStateAction } from "react";
import {
  FormControlLabel,
  FormGroup,
  IconButton,
  Menu,
  Radio,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { North, South } from "@mui/icons-material";

export interface MenuSortProps {
  options?: string[];
  setSort?: Dispatch<SetStateAction<number>> | ((value: number) => void);
  sort?: number;
  direction?: boolean;
  setDirection?: Dispatch<SetStateAction<boolean>> | ((value: boolean) => void);
  anchorEl: null | HTMLElement;
  setAnchorEl?:
    | Dispatch<SetStateAction<null | HTMLElement>>
    | ((value: null | HTMLElement) => void);
}

export default function MenuSort({
  options = [],
  setSort = () => {},
  sort = 0,
  direction = false,
  setDirection = () => {},
  anchorEl,
  setAnchorEl = () => {},
}: MenuSortProps) {
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      sx={{
        "& .MuiMenu-list": {
          p: "0px",
        },
        zIndex: 9999,
      }}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <Stack sx={{ padding: "12px", minWidth: "170px" }}>
        <Typography>Ordenar por</Typography>
        <Stack sx={{ paddingX: "10px" }}>
          <FormGroup>
            {options.map((op, index) => (
              <Stack
                direction={"row"}
                gap={1}
                alignItems={"center"}
                key={index + "menus"}
              >
                <FormControlLabel
                  control={
                    <Radio
                      checked={sort === index}
                      onClick={() => {
                        if (sort === index) {
                          setDirection(!direction);
                        }
                      }}
                      onChange={() => {
                        setSort(index);
                      }}
                    />
                  }
                  label={op}
                />
                {sort === index && (
                  <Tooltip
                    title={direction === false ? "Crescente" : "Descrecente"}
                  >
                    <IconButton
                      onClick={() => {
                        setDirection(!direction);
                      }}
                      size="small"
                      color="primary"
                      sx={{ ml: "-20px" }}
                    >
                      {direction === false ? (
                        <North sx={{ fontSize: "15px" }} />
                      ) : (
                        <South sx={{ fontSize: "15px" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            ))}
          </FormGroup>
        </Stack>
      </Stack>
    </Menu>
  );
}
